import {
  ABOUT_US,
  ABOUT_US_FAILURE,
  ABOUT_US_SUCCESS,
  COOKIES,
  COOKIES_FAILURE,
  COOKIES_SUCCESS,
  GET_ABOUT_US,
  GET_ABOUT_US_FAILURE,
  GET_ABOUT_US_SUCCESS,
  GET_COOKIES,
  GET_COOKIES_FAILURE,
  GET_COOKIES_SUCCESS,
  GET_HOME_DATA,
  GET_HOME_DATA_FAILURE,
  GET_HOME_DATA_SUCCESS,
  GET_PRIVACY_POLICY,
  GET_PRIVACY_POLICY_FAILURE,
  GET_PRIVACY_POLICY_SUCCESS,
  GET_SUBSCRIPTION_POLICY,
  GET_SUBSCRIPTION_POLICY_FAILURE,
  GET_SUBSCRIPTION_POLICY_SUCCESS,
  GET_TERM_CONDITION,
  GET_TERM_CONDITION_FAILURE,
  GET_TERM_CONDITION_SUCCESS,
  PRIVACY_POLICY,
  PRIVACY_POLICY_FAILURE,
  PRIVACY_POLICY_SUCCESS,
  SUBSCRIPTION_POLICY,
  SUBSCRIPTION_POLICY_FAILURE,
  SUBSCRIPTION_POLICY_SUCCESS,
  TERM_CONDITION,
  TERM_CONDITION_FAILURE,
  TERM_CONDITION_SUCCESS,
  UPDATE_HOME_DATA,
  UPDATE_HOME_DATA_FAILURE,
  UPDATE_HOME_DATA_SUCCESS,
} from '../Actiontype';

export const setPrivacyPolicy = data => ({
  payload: data,
  type: PRIVACY_POLICY,
});
export const PrivacyPolicySuccess = response => ({
  payload: response,
  type: PRIVACY_POLICY_SUCCESS,
});
export const PrivacyPolicyFailure = response => ({
  payload: response,
  type: PRIVACY_POLICY_FAILURE,
});

export const setTermandCond = data => ({
  payload: data,
  type: TERM_CONDITION,
});
export const setTermandCondSuccess = response => ({
  payload: response,
  type: TERM_CONDITION_SUCCESS,
});
export const setTermandCondFailure = response => ({
  payload: response,
  type: TERM_CONDITION_FAILURE,
});

export const setCookies = data => ({
  payload: data,
  type: COOKIES,
});
export const setCookiesSuccess = response => ({
  payload: response,
  type: COOKIES_SUCCESS,
});
export const setCookiesFailure = response => ({
  payload: response,
  type: COOKIES_FAILURE,
});

export const setAboutus = data => ({
  payload: data,
  type: ABOUT_US,
});
export const setAboutusSuccess = response => ({
  payload: response,
  type: ABOUT_US_SUCCESS,
});
export const setAboutusFailure = response => ({
  payload: response,
  type: ABOUT_US_FAILURE,
});

export const getPrivacyPolicy = () => ({
  type: GET_PRIVACY_POLICY,
});
export const getPrivacyPolicySuccess = response => ({
  payload: response,
  type: GET_PRIVACY_POLICY_SUCCESS,
});
export const getPrivacyPolicyFailure = response => ({
  payload: response,
  type: GET_PRIVACY_POLICY_FAILURE,
});

export const getTermandCond = () => ({
  type: GET_TERM_CONDITION,
});
export const getTermandCondSuccess = response => ({
  payload: response,
  type: GET_TERM_CONDITION_SUCCESS,
});
export const getTermandCondFailure = response => ({
  payload: response,
  type: GET_TERM_CONDITION_FAILURE,
});

export const getCookies = () => ({
  type: GET_COOKIES,
});
export const getCookiesSuccess = response => ({
  payload: response,
  type: GET_COOKIES_SUCCESS,
});
export const getCookiesFailure = response => ({
  payload: response,
  type: GET_COOKIES_FAILURE,
});

export const getAboutus = () => ({
  type: GET_ABOUT_US,
});
export const getAboutusSuccess = response => ({
  payload: response,
  type: GET_ABOUT_US_SUCCESS,
});
export const getAboutusFailure = response => ({
  payload: response,
  type: GET_ABOUT_US_FAILURE,
});

export const setSubscriptionpolicy = data => ({
  payload: data,
  type: SUBSCRIPTION_POLICY,
});
export const setSubscriptionpolicySuccess = response => ({
  payload: response,
  type: SUBSCRIPTION_POLICY_SUCCESS,
});
export const setSubscriptionpolicyFailure = response => ({
  payload: response,
  type: SUBSCRIPTION_POLICY_FAILURE,
});

export const getSubscriptionpolicy = () => ({
  type: GET_SUBSCRIPTION_POLICY,
});
export const getSubscriptionpolicySuccess = response => ({
  payload: response,
  type: GET_SUBSCRIPTION_POLICY_SUCCESS,
});
export const getSubscriptionpolicyFailure = response => ({
  payload: response,
  type: GET_SUBSCRIPTION_POLICY_FAILURE,
});

export const setHomedata = data => ({
  payload: data,
  type: UPDATE_HOME_DATA,
});
export const setHomedataSuccess = response => ({
  payload: response,
  type: UPDATE_HOME_DATA_SUCCESS,
});
export const setHomedataFailure = response => ({
  payload: response,
  type: UPDATE_HOME_DATA_FAILURE,
});

export const getHomedata = () => ({
  type: GET_HOME_DATA,
});
export const getHomedataSuccess = response => ({
  payload: response,
  type: GET_HOME_DATA_SUCCESS,
});
export const getHomedataFailure = response => ({
  payload: response,
  type: GET_HOME_DATA_FAILURE,
});
